<template>
  <!-- 
    入参：
        template：模版id，多个模版 id 以逗号隔开
        success： 选填
        error： 选填
    使用：
        不建议在wx-open-subscribe 写内容，现方案：此组件absolute 悬浮盖在业务按钮上即可
        优势：即使wx-open-subscribe 无法正常显示时候页面还能正常显示，并且业务按钮上还可以写容错逻辑

        import WxSubscribe from '@/components/wx-subscribe';
        <div>        
            <button @click='onClick'> 订阅通知</button>
            <WxSubscribe :template="`QMwqm47plhsKooTC4Idf89-Ou21gdZtvhGES6bre84M`"></WxSubscribe>
        </div>
    -->
  <div>
    <wx-open-subscribe
      :ref="id"
      class="box-app"
      :template="template"
    >
      <script type="text/wxtag-template" slot="style">
        <style>
          .subscribe-btn {
            height:100%;
            width:100%;
            position: absolute;
            top: 0;
            left: 0;
          }
        </style>
      </script>
      <script type="text/wxtag-template">
        <div class="subscribe-btn" >&nbsp</div>
        <!-- <slot></slot> -->
      </script>
    </wx-open-subscribe>
  </div>
</template>

<script>
export default {
  name: 'WxSubscribe',
  props: {
    template: {
      type: String,
    },
    success: {
      type: Function,
    },
    error: {
      type: Function,
    },
  },
  data() {
    return {
      id: Math.random().toString(16).substr(2),
    };
  },
  mounted() {
    if (this.success) {
      const dom = this.$refs[this.id];
      dom.addEventListener('success', e => {
        this.success(e);
      });
    }
    if (this.error) {
      const dom = this.$refs[this.id];
      dom.addEventListener('error', e => {
        this.error(e);
      });
    }
  },
};
</script>

<style scoped>
.box-app {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/wx-subscribe.vue